import React, {useState} from 'react'
import {SummaryEmployeesButtons} from "./SummaryEmployeesButtons";
import {Translate} from "../../../components/translate/Translate";
import axios from "axios";
import {getApiLink} from "../../../functions/getApiLink";
import {SetSummaryEmployees} from "../../../api/SetSummaryEmployees";
import {useDispatch, useSelector} from 'react-redux';
import {SummaryAllProjects} from "../../../components/summaryAllProjects/SummaryAllProjects";
import { IUser } from '../../../models';
// Note: chosenTimesheet removed — month/year parsed from itemData.date directly

interface ISummaryEmployeesChangeDecisionProps {
    itemData: any
    handleExportPdf: any
    isClickToExport: boolean
    isCanApprove?: boolean
}

export const SummaryEmployeesChangeDecision: React.FC<ISummaryEmployeesChangeDecisionProps> = ({itemData, handleExportPdf, isClickToExport, isCanApprove}) => {

    const dispatch = useDispatch()

    const user: IUser = useSelector((state: any) => state.toolkit.user)
    const [loading, setLoading] = useState(false)

    const handleChangeDecision = () => {
        if (loading) return
        setLoading(true)

        // itemData.date format from backend: "dd/mm/yy"
        const parts = itemData?.date?.split('/')
        const now = new Date()
        const actualMonth = parts ? parseInt(parts[1], 10) : (now.getMonth() + 1)
        const actualYear = parts ? (2000 + parseInt(parts[2], 10)) : now.getFullYear()

        axios.post(getApiLink(`/api/timesheet/employees/review/?timesheet_id=${itemData?.id}&status=waiting`))
            .then(({data}) => {
                if(!data?.status) return;
                SetSummaryEmployees(dispatch, user, actualMonth, actualYear)
            })
            .catch(() => {
                SetSummaryEmployees(dispatch, user, actualMonth, actualYear)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    

    return (
        <div className="summary-item__footer--col">
            <SummaryAllProjects/>
            <button disabled={isClickToExport} onClick={handleExportPdf} className="summary-item__button btn is-grey is-transparent" type="button">
                Export monthly summary
                <svg width="16" height="17" viewBox="0 0 16 17">
                    <use xlinkHref="#download"></use>
                </svg>
            </button>
            <a onClick={handleChangeDecision} className={`summary-item__button btn open-popup is-grey${loading ? ' is-disabled' : ''}`}
               style={loading ? {pointerEvents: 'none', opacity: 0.6} : undefined}
               type="button">
                <Translate>employees_page.table.change_decision</Translate>
            </a>
        </div>
    )
}
